import { OnInit, Component, DoCheck, KeyValueDiffers, HostListener, ViewChild, TemplateRef } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree'
import { first } from 'rxjs/operators';
import { User, CategoryNode } from '../../../_models';
import { AuthenticationService } from '../../../_services/authentication.service';
import { CategoryService } from '../../../_services/category.service';
import { UserService } from '../../../_services/user.service'
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, Validators, FormArray, FormGroup, FormControl } from '@angular/forms';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DialogDeleteConfirmComponent } from 'src/app/dialog-delete-confirm/dialog-delete-confirm.component';
import { AppConfig } from 'src/assets/config/config/app-config';
import cloneDeep from 'lodash/cloneDeep';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import { VirtualFolderService } from 'src/app/_services/virtualFolder.service';
import * as uuid from 'uuid';
@Component({
  selector: 'app-redaction-profiles',
  templateUrl: './redaction-profiles.component.html',
  styleUrls: ['./redaction-profiles.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class RedactionProfilesComponent implements OnInit {
  redactionProfilesTableArray = [];
  redactionProfilesDataSource = new MatTableDataSource(this.redactionProfilesTableArray);
  isAdmin: boolean = false;
  currentUser: User;
  userGroups: string[];
  displayedColumns: string[] = ['profileId', 'profileName', 'selectedFields', 'actions'];
  enableNewProfilePage: boolean = false;
  enableUpdateProfilePage: boolean = false;
  selectedProfile = null;
  allFieldsList = [];
  piiList = [];
  phiList = [];
  customList = [];
  profileForm: FormGroup;
  button: string = 'Save';
  expansionPanelExpanded = [false, false, false]
  selectAllPiiToggle = false;
  selectAllPhiToggle = false;
  addCustomFieldPopupRef = null;
  deleteCustomFieldPopupRef = null;
  customFieldIndex = null;
  customFieldName = null;
  saveUpdateCustomFieldButton = 'save'
  tempProfileId = null;
  deleteProfilePopupRef = null;
  profileToBeDeleted: any;
  @ViewChild('addCustomFieldPopup', { static: false }) addCustomFieldPopup: TemplateRef<any>;
  @ViewChild('deletecustomFieldPopup', { static: false }) deletecustomFieldPopup: TemplateRef<any>;
  @ViewChild('deleteProfilePopup', { static: false }) deleteProfilePopup: TemplateRef<any>;
 
  constructor(
    private authenticationService: AuthenticationService,
    private categoryService: CategoryService,
    private virtualFolderService: VirtualFolderService,
    private userService: UserService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private usersGroupsService: UsersAndGroupsService,
    private config: AppConfig,) { }

  async ngOnInit() {
    this.redactionProfilesTableArray = (await this.categoryService.getRedactionProfilesList().toPromise())['Entities'];
    console.log(this.redactionProfilesTableArray);
   
    this.allFieldsList = (await this.categoryService.getAllFields().toPromise())['Entities'];
    console.log( this.allFieldsList);
    this.differentiatePiiPhiFields();
    this.addSelectedFieldNames();
    this.redactionProfilesDataSource = new MatTableDataSource([...this.redactionProfilesTableArray]);
    if (this.userGroups != null) {
      var adminGroup
      this.usersGroupsService.getAdminGroupName().subscribe(admin => {
        adminGroup = admin
        console.log(admin, this.userGroups);
        for (let i = 0; i < this.userGroups.length; i++) {
          console.log(this.userGroups[i]);
          //if (group.match(adminGroup)) {
          if (adminGroup.indexOf(this.userGroups[i]) >= 0) {
            this.isAdmin = true;
            break;
          }
        }
      })
    }
  }

  differentiatePiiPhiFields() {
    for(let i = 0; i < this.allFieldsList.length; i++) {
      if(this.allFieldsList[i]['Field Type'] === 'pii') {
        if(this.piiList.findIndex(ele => ele['ID'] === this.allFieldsList[i]['ID'] && ele['Field Name'] === this.allFieldsList[i]['Field Name']) == -1) {
          this.piiList.push(this.allFieldsList[i]);
        }
      } else {
        if(this.phiList.findIndex(ele => ele['ID'] === this.allFieldsList[i]['ID'] && ele['Field Name'] === this.allFieldsList[i]['Field Name']) == -1) {
          this.phiList.push(this.allFieldsList[i]);
        }
      }
    }
    console.log(this.piiList, this.phiList);
  }

  addSelectedFieldNames() {
    for (let i = 0; i < this.redactionProfilesTableArray.length; i++) {
      let tempFieldArr = [];
      let tempFieldobjArr = [];
      for (let j = 0; j < this.redactionProfilesTableArray[i]['Fields Selected'].length; j++) {
        let tempObj = this.allFieldsList.find(ele => ele['ID'] === this.redactionProfilesTableArray[i]['Fields Selected'][j])
        if(tempObj != undefined) {
          tempFieldobjArr.push(tempObj);
          console.log(tempObj);
          tempFieldArr.push(tempObj['Field Name']);
        }        
      }
      this.redactionProfilesTableArray[i]['selectedFieldNames'] = [...tempFieldArr];
      this.redactionProfilesTableArray[i]['selectedFieldsObjs'] = [...tempFieldobjArr];
    }
  }

  async enableNewProfile(action, selectedProfileObj?) {
    if (action == 'new') {
      this.enableNewProfilePage = true;
      this.enableUpdateProfilePage = false;
      this.initiateNewForm();
      this.button = 'Save';
    } else if (action == 'update') {
      console.log(selectedProfileObj);
      this.customList = [...selectedProfileObj['Custom Fields']['Fields']]
      console.log(this.customList);
      this.enableUpdateProfilePage = true;
      this.enableNewProfilePage = false;
      this.selectedProfile = cloneDeep(selectedProfileObj);
      this.initiateUpdateForm(selectedProfileObj);
      this.button = 'Update';
    }
  }

  initiateNewForm(): void {
    this.profileForm = this.fb.group({
      profileName: new FormControl('', Validators.required),
      selectedPiiFields: new FormControl([]),
      selectedPhiFields: new FormControl([]),
      selectedCustomFields: new FormControl([])
    })
  }

  initiateUpdateForm(selectedProfileObj?) {
    let tempSelectedPiiArr = [];
    let tempSelectedPhiArr = [];
    let tempSelectedCustomFields = [];
    for(let i = 0; i < selectedProfileObj['selectedFieldsObjs'].length; i++) {
      if(this.piiList.some(ele => ele['ID'] === selectedProfileObj['selectedFieldsObjs'][i]['ID'])) {
        tempSelectedPiiArr.push(selectedProfileObj['selectedFieldsObjs'][i]);
        console.log('INSIDE')
        if(tempSelectedPiiArr.length === 1) {
          this.expansionPanelExpanded[0] = true;
        }
      } else if (this.phiList.some(ele => ele['ID'] === selectedProfileObj['selectedFieldsObjs'][i]['ID'])) {
        tempSelectedPhiArr.push(selectedProfileObj['selectedFieldsObjs'][i]);
        if(tempSelectedPhiArr.length === 1) {
          this.expansionPanelExpanded[1] = true;
        }
      }
    }

    for(let i = 0; i < selectedProfileObj['Custom Fields']['Fields'].length; i++) {
      if(selectedProfileObj['Custom Fields']['Fields'][i]['selected'] === true) {
        tempSelectedCustomFields.push(selectedProfileObj['Custom Fields']['Fields'][i]);
        this.expansionPanelExpanded[2] = true;
      }
    }

    if(selectedProfileObj) {
      this.profileForm = this.fb.group({
        profileName: new FormControl(selectedProfileObj['Profile Name'], Validators.required),
        selectedPiiFields: new FormControl([...tempSelectedPiiArr]),
        selectedPhiFields: new FormControl([...tempSelectedPhiArr]),
        selectedCustomFields: new FormControl([...tempSelectedCustomFields])
      })
    }

    this.selectAllPiiToggle = tempSelectedPiiArr.length === this.piiList.length ? true : false;
    this.selectAllPhiToggle = tempSelectedPhiArr.length === this.phiList.length ? true : false;
  }

  selectDeselectAllPiiFields(e?) {
    if(e['checked']) {
      this.selectAllPiiToggle = true;
      this.profileForm.controls.selectedPiiFields.setValue([...this.piiList])
    } else if (!e['checked']) {
      this.selectAllPiiToggle = false;
      this.profileForm.controls.selectedPiiFields.setValue([])
    }
  }

  selectDeselectAllPhiFields(e?) {
    if(e['checked']) {
      this.selectAllPhiToggle = true;
      this.profileForm.controls.selectedPhiFields.setValue([...this.phiList])
    } else if (!e['checked']) {
      this.selectAllPhiToggle = false;
      this.profileForm.controls.selectedPhiFields.setValue([])
    }
  }

  applyFilter(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value;
    this.redactionProfilesDataSource.filter = filterValue;
  }

  onSelectPiiFields(piifield) {
    let tempArr = [...this.profileForm.controls.selectedPiiFields.value];
    const index = tempArr.findIndex(ele => ele['Field Name'] === piifield['Field Name']);
    console.log(index);
    if(index === -1) {
      tempArr.push(piifield);
    } else {
      tempArr.splice(index, 1)
    }
    console.log(tempArr)
    this.profileForm.controls.selectedPiiFields.setValue(tempArr);
    this.selectAllPiiToggle = tempArr.length === this.piiList.length ? true:false;
  }

  onSelectPhiFields(phifield) {
    let tempArr = [...this.profileForm.controls.selectedPhiFields.value];
    const index = tempArr.findIndex(ele => ele['Field Name'] === phifield['Field Name']);
    if(index === -1) {
      tempArr.push(phifield);
    } else {
      tempArr.splice(index, 1)
    }
    console.log(tempArr)
    this.profileForm.controls.selectedPhiFields.setValue([...tempArr]);
    this.selectAllPhiToggle = tempArr.length === this.phiList.length ? true:false;
  }

  onSelectCustomFields(customField) {
    let tempArr = [...this.profileForm.controls.selectedCustomFields.value];
    const index = tempArr.findIndex(ele => ele['value'] == customField['value']);
    if(index === -1) {
      customField['selected'] = true;
      tempArr.push(customField);
    } else {
      customField['selected'] = false;
      tempArr.splice(index, 1)
    }
    console.log(tempArr)
    this.profileForm.controls.selectedCustomFields.setValue([...tempArr]);
    //this.selectAllPiiToggle = tempArr.length === this.piiList.length ? true:false;
  }

  async toggleAddCustomFieldPopup(action, index?) {
    if(action === 'open') {
      this.saveUpdateCustomFieldButton = 'save';
      this.addCustomFieldPopupRef = this.dialog.open(this.addCustomFieldPopup);

    } else if (action === 'openForEdit') {
      if(index != undefined) {
        this.saveUpdateCustomFieldButton = 'update';
        this.addCustomFieldPopupRef = this.dialog.open(this.addCustomFieldPopup);
        this.customFieldName = this.customList[index]['value'];
        this.customFieldIndex = index;
      }
    } else if (action === 'close') {
      if(this.addCustomFieldPopupRef) {
        this.customFieldName = null;
        this.addCustomFieldPopupRef.close();
        this.addCustomFieldPopupRef = null;
        this.saveUpdateCustomFieldButton = 'save';
        this.customFieldIndex = null;
      }
    } else if (action === 'save') {
      if(this.addCustomFieldPopupRef) {
        if(this.customFieldName != null) {
          // Create new custom field
          let payload;

          //COMPLETELY NEW PROFILE
          if(this.tempProfileId === null && this.selectedProfile === null) {
            payload = {
              "type": "Field Title",
              "selected": true,
              "value": this.customFieldName,
              "synonyms": [this.customFieldName],
              "id": uuid.v4()
            }            
          } else if (this.tempProfileId != null && this.selectedProfile === null) { //NEW PROFILE BUT WITH ALREADY CREATED CUSTOM FIELD
            payload = {
              "profileId": this.tempProfileId.toString(),
              "type": "Field Title",
              "selected": true,
              "value": this.customFieldName,
              "synonyms": [this.customFieldName],
              "id": uuid.v4()
            }

          } else if (this.tempProfileId === null && this.selectedProfile != null) { //ADDING CUSTOM FIELDS TO ALREADY CREATED PROFILES
            payload = {
              "profileId": this.selectedProfile['Profile ID'].toString(),
              "type": "Field Title",
              "selected": true,
              "value": this.customFieldName,
              "synonyms": [this.customFieldName],
              "id": uuid.v4()
            }
           
          } 
          console.log(payload);    
          this.customList.push(payload);
          this.onSelectCustomFields(payload);
          console.log(this.customList);
          this.customFieldName = null;
        }

        this.addCustomFieldPopupRef.close();
        this.saveUpdateCustomFieldButton = 'save';
        this.addCustomFieldPopupRef = null;
        this.customFieldIndex = null;
      }
    } else if (action === 'update') {
      if(this.customFieldIndex != null) {
        if(this.customFieldName != null) {
          //Create new custom field
          let temp = this.customList[this.customFieldIndex];
          let prevVal = temp['value'];
          for(let i = 0; i < temp['synonyms'].length; i++) {
            if(temp['synonyms'][i] === prevVal) {
              temp['synonyms'][i] = this.customFieldName;
            }
          }
          console.log(temp);
          temp['value'] = (this.customFieldName);
          console.log(this.customList);
          this.customFieldName = null;
        }
      }
      this.addCustomFieldPopupRef.close();
      this.saveUpdateCustomFieldButton = 'save';
      this.addCustomFieldPopupRef = null;
      this.customFieldIndex = null;
    } else if (action === 'delete') {
      if(this.addCustomFieldPopupRef != null) {
        this.saveUpdateCustomFieldButton = 'save';
        this.deleteCustomFieldActions('open');
        this.addCustomFieldPopupRef.close();
        this.addCustomFieldPopupRef = null;
      }
    }
  }

  async deleteCustomFieldActions(action) {
    if(action === 'delete' && this.customFieldIndex != null) {
      this.customList.splice(this.customFieldIndex, 1);
      console.log(this.customList);
      this.customFieldName = null;
      this.customFieldIndex = null;
      this.deleteCustomFieldPopupRef.close();
      this.deleteCustomFieldPopupRef = null;     
    } else if (action === 'close') {
      if(this.deleteCustomFieldPopupRef) {
        //this.customList.splice(this.customFieldIndex, 1);
        console.log(this.customList);
        this.customFieldName = null;
        this.customFieldIndex = null;
        this.deleteCustomFieldPopupRef.close();
        this.deleteCustomFieldPopupRef = null;
      } 
    } else if (action === 'open') {
      this.deleteCustomFieldPopupRef = this.dialog.open(this.deletecustomFieldPopup);
    }
  }

  async confirmDeleteProfile(action) {
    if(action === 'delete') {
      if(this.profileToBeDeleted != null || this.profileToBeDeleted != undefined) {
        await this.categoryService.deleteProfilesEntry(this.profileToBeDeleted).toPromise();
        if(this.deleteProfilePopupRef != null || this.deleteProfilePopupRef != undefined) {
          this.deleteProfilePopupRef.close();
        }
        this.resetValues();
        this.piiList = [];
        this.phiList = [];
        this.ngOnInit();
      }     
    }
    
    if(this.deleteProfilePopupRef != null || this.deleteProfilePopupRef != undefined) {
      this.deleteProfilePopupRef.close();
    }
  }

  async deleteProfile(id) {
    this.profileToBeDeleted = id;
    this.deleteProfilePopupRef = this.dialog.open(this.deleteProfilePopup);    
  }

  resetValues() {
    this.enableNewProfilePage = false;
    this.enableUpdateProfilePage = false;
    this.selectedProfile = null;
    this.button = 'Save';
    this.profileForm ? this.profileForm.reset() : null;
    this.expansionPanelExpanded = [false, false, false]
    this.selectAllPiiToggle = false;
    this.selectAllPhiToggle = false;
    this.addCustomFieldPopupRef = null;
    this.customFieldName = null;
    this.tempProfileId = null;
    this.customList = [];  
    // redactionProfilesTableArray = [];
    // redactionProfilesDataSource = new MatTableDataSource(this.redactionProfilesTableArray);
    // isAdmin: boolean = false;
    // currentUser: User;
    // userGroups: string[];
    // displayedColumns: string[] = ['profileId', 'profileName', 'selectedFields', 'actions'];
    // this.piiList = [];
    // this.phiList = [];
    // this.allFieldsList = [];
    // this.deleteCustomFieldPopupRef = null;
    // this.customFieldIndex = null;
    // this.saveUpdateCustomFieldButton = 'save'
    // this.deleteProfilePopupRef = null;
    // this.profileToBeDeleted: any; 
  }

  back() {
    this.resetValues();
  }

  async save() {
    let selectedFields = []
    for(let i = 0; i < this.profileForm.value['selectedPiiFields'].length; i++) {
      selectedFields.push(this.profileForm.value['selectedPiiFields'][i]['ID'])
    }
    for(let i = 0; i < this.profileForm.value['selectedPhiFields'].length; i++) {
      selectedFields.push(this.profileForm.value['selectedPhiFields'][i]['ID'])
    }
    let payload;
    if (this.selectedProfile === null) {
      if (this.tempProfileId === null) {
        payload = {
          "name": this.profileForm.value['profileName'],
          "fieldsSelected": selectedFields,
          "customFields": {
            "Fields": this.customList
          }
        }
        await this.categoryService.createProfilesEntry(payload).toPromise()
      } else {
        payload = {
          "profileId": this.tempProfileId,
          "name": this.profileForm.value['profileName'],
          "fieldsSelected": selectedFields,
          "customFields": {
            "Fields": this.customList
          }
        }
        await this.categoryService.updateProfilesEntry(payload).toPromise();
      }
    } else {
      payload = {
        "profileId": this.selectedProfile['Profile ID'],
        "name": this.profileForm.value['profileName'],
        "fieldsSelected": selectedFields,
        "customFields": {
          "Fields": this.customList
        }
      }
      await this.categoryService.updateProfilesEntry(payload).toPromise();
    }
    this.resetValues();
    this.piiList = [];
    this.phiList = [];
    this.ngOnInit();
  }

  // async update() {
  //   let selectedFields = []
  //   for(let i = 0; i < this.profileForm.value['selectedPiiFields'].length; i++) {
  //     selectedFields.push(this.profileForm.value['selectedPiiFields'][i]['ID'])
  //   }
  //   for(let i = 0; i < this.profileForm.value['selectedPhiFields'].length; i++) {
  //     selectedFields.push(this.profileForm.value['selectedPhiFields'][i]['ID'])
  //   }
  //   let updatePayload = {
  //     "profileId": this.selectedProfile['Profile ID'],
  //     "name": this.profileForm.value['profileName'],
  //     "fieldsSelected": selectedFields,
  //     "customFields": {
  //       "Fields": this.customList
  //     }
  //   }
  //   console.log(this.profileForm.value, updatePayload)
  // }

}
